import { type Theme } from '@direct-frontend/components';
import { kitDarkTheme, kitLightTheme, type ThemeColor } from '../themekit';
import { DARK_COLOR_SCHEME_QUERY } from './constants';
import { getThemeMode } from './themeMode';
import { type ThemeMode } from './types';

export const resolveThemeColor = ({ isSystemDark, mode }: { isSystemDark: boolean; mode: ThemeMode }): ThemeColor => {
    if (mode === 'dark' || (mode === 'system' && isSystemDark)) {
        return 'dark';
    }

    return 'light';
};

export const getThemeColor = (): ThemeColor => {
    const mode = getThemeMode();
    const isServer = typeof window === 'undefined';

    return resolveThemeColor({
        // На SSR для system не знаем prefers-color-scheme — считаем light
        isSystemDark:
            !isServer && typeof window.matchMedia === 'function' && window.matchMedia(DARK_COLOR_SCHEME_QUERY).matches,
        mode,
    });
};

export const getTheme = (): Theme => (getThemeColor() === 'dark' ? kitDarkTheme : kitLightTheme);
